import { useEffect, useState } from 'react';

const useHiddenSection = ({
  isHiddenOnlyFirst = true,
  isShow = false,
  deps = [],
}) => {
  const [isForceShow, setForceShow] = useState(false);

  useEffect(() => {
    if (!isShow) {
      if (isHiddenOnlyFirst) return;
      setForceShow(false);
      return;
    }
    setForceShow(true);
  }, [isShow, ...deps]);

  return isForceShow;
};

export default useHiddenSection;
